import { useState, useEffect } from 'react';

export const useToggleTableVariant = ({ tableKey }) => {
  const savedTableState = JSON.parse(localStorage.getItem(tableKey));

  const [tableVariant, setTableVariant] = useState(savedTableState?.tableVariant || 'legacy');

  const handleSelectNewVariant = () => {
    setTableVariant('new');
  };

  const handleSelectLegacyVariant = () => {
    setTableVariant('legacy');
  };

  useEffect(() => {
    localStorage.setItem(tableKey, JSON.stringify({ ...savedTableState, tableVariant }));
  }, [tableVariant]);

  return {
    tableVariant,
    handleSelectNewVariant,
    handleSelectLegacyVariant,
  };
};
